'use client'

import { useModel } from '../hooks/useModel'
import { useNodeMaterials } from '../hooks/useNodeMaterials'

export function McDonalds(props) {
  const { nodes, materials } = useModel('/models/retroMaccies_mat.glb')
  const { getMat } = useNodeMaterials(materials)

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.McDonalds.geometry} material={getMat(nodes.McDonalds)} castShadow receiveShadow />
      <mesh geometry={nodes.Arc_1.geometry} material={getMat(nodes.Arc_1)} castShadow receiveShadow />
      <mesh geometry={nodes.Arc_2.geometry} material={getMat(nodes.Arc_2)} castShadow receiveShadow />
      <mesh geometry={nodes.Flo0r.geometry} material={getMat(nodes.Flo0r)} castShadow receiveShadow />
    </group>
  )
}

